import { Tooltip } from '@mui/material';
import React, { FC } from 'react';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/Error';
import { useStyles } from './BracketSeedTeamStatus.styles';

interface BracketSeedTeamStatusProps {
  isReady?: boolean;
}

export const BracketSeedTeamStatus: FC<BracketSeedTeamStatusProps> = ({ isReady }) => {
  const { classes } = useStyles();

  if (!isReady) {
    return (
      <Tooltip title="Not Ready">
        <ErrorIcon className={classes.error} />
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Ready">
      <DoneIcon className={classes.success} />
    </Tooltip>
  );
};
